import Logo from "@/assets/myth-icon.svg?react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";
import Bench from "@/assets/bench.svg?react";
import { Token } from "@/components/token";
import { dsDisabled } from "@/config";
import { useEffect, useState } from "react";
import { shuffle } from "lodash";
import { useListings } from "@/hooks/use-listings";

export function Home() {
  const { data: listings } = useListings()
  const [dualStakeAsa, setDualStakeAsa] = useState(796425061);

  useEffect(() => {
    if (listings?.size) {
      const shuffled = shuffle([...listings.values()]);
      setDualStakeAsa(Number(shuffled[0].asaId));
    }
  }, [listings]);

  return (
    <div className="flex-grow self-stretch flex flex-col md:flex-row items-center justify-center overflow-hidden gap-4">
      <div className="absolute z-[-1] left-0 top-0 right-0 bottom-0 flex justify-center items-start pt-12 md:pt-24 overflow-hidden">
        <Logo
          style={{
            height: "calc(min(90vw, 100svh))",
            opacity: 0.015,
            maskImage:
              "linear-gradient(rgb(255, 255, 255), rgba(255, 255, 255, 0.3) 30%, rgba(0, 0, 0, 0) 80%)",
          }}
        />
      </div>

      {dsDisabled ? null : (
        <Link to="/dualSTAKE" className="opacity-0 animate-fade-in-1">
          <Card
            glowing="primary"
            className="w-[250px] h-[215px] relative group bg-card/80 flex flex-col hover:border-primary hover:scale-105 transition-all text-muted-foreground hover:text-foreground"
          >
            <CardHeader>
              <CardTitle className="text-xl flex gap-1 justify-center">
                <div className="relative">
                  <span className="">dualSTAKE</span>
                  <span className="font-thin text-xs absolute text-muted-foreground left-[100%] ml-[3px]">
                    beta
                  </span>
                </div>
              </CardTitle>
            </CardHeader>
            <CardContent className="flex w-full z-8 flex-col flex-grow pb-0 pt-4 -mt-5 items-center gap-5 text-sm overflow-y-visible">
              <div className="transition-all flex flex-col items-center opacity-75 group-hover:opacity-100">
                <Token
                  variant="sm"
                  shadowVariant="xs"
                  leftAssetId={dualStakeAsa}
                  rightAssetId={0}
                />
              </div>
              <div className="flex-col flex items-center gap-0 -mt-1">
                <div>Dual liquid staking</div>
                <div className="font-light text-muted-foreground">
                  with ASA rewards
                </div>
              </div>
            </CardContent>
          </Card>
        </Link>
      )}

      <Link to="/bench" className="opacity-0 animate-fade-in-2">
        <Card
          glowing="primary"
          className="w-[250px] h-[215px] relative group bg-card/80 hover:border-primary hover:scale-105 transition-all text-muted-foreground hover:text-foreground"
        >
          <CardHeader>
            <CardTitle className="text-xl flex gap-1 justify-center">
              <div className="relative">
                <span className="">Bench</span>
                <span className="font-thin text-xs absolute text-muted-foreground left-[100%] ml-[3px]">
                  beta
                </span>
              </div>
            </CardTitle>
          </CardHeader>
          <CardContent className="flex w-full flex-col pt-2 pb-5 -mt-5 items-center gap-5 text-sm overflow-y-visible">
            <div className="flex flex-col items-center">
              <div className="invisible text-primary/20 group-hover:text-primary text-primary font-thin -mb-[0.2rem] text-[1.4rem] group-hover:animate-bounce group-hover:visible">
                ¥
              </div>
              <Bench className="text-primary/50 group-hover:text-primary" />
            </div>
            <div className="flex-col flex items-center gap-0">
              <div>Constant price markets</div>
              <div className="font-light text-muted-foreground">
                ASA &middot; ALGO
              </div>
            </div>
          </CardContent>
        </Card>
      </Link>
    </div>
  );
}
